import React from 'react'
import Layouts from '../../Layouts/Layouts'
import { StyledMainPageRightSection } from '../dashboard/style.dashboard'

const Tickets = () => {
  return (
    <>
      <Layouts>

        <StyledMainPageRightSection>

          <h1>ON Tickets</h1>
        </StyledMainPageRightSection>
      </Layouts>
     
    </>
  )
}

export default Tickets
